const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgItemSearch = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 692 480",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.063,
    cy: 351.96,
    rx: 276.063,
    ry: 123.045,
    style: {
      fill: "#f4f5fa",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.743,130.803l82.306,96.648l0,172.762l-82.028,-96.994l-0.278,-172.416Z",
    style: {
      fill: "#ffb801",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.138,210.189l-231.146,17.276l0,172.761l231.425,-17.621l-0.279,-172.416Z",
    style: {
      fill: "#ffcc47",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.776,117.317l99.337,92.86l-231.065,17.274l-82.311,-96.651l214.039,-13.483Z",
    style: {
      fill: "#ffe8ac",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.172,16.93c95.356,9.344 165.187,94.347 155.843,189.703c-9.344,95.356 -94.347,165.187 -189.703,155.843c-95.356,-9.344 -165.187,-94.347 -155.843,-189.703c9.344,-95.356 94.347,-165.187 189.703,-155.843Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.755,31.389c87.375,8.562 151.362,86.451 142.801,173.827c-8.562,87.375 -86.451,151.362 -173.827,142.8c-87.375,-8.561 -151.362,-86.45 -142.8,-173.826c8.561,-87.375 86.45,-151.362 173.826,-142.801Z",
    style: {
      fill: "none",
      stroke: "#0c193b",
      strokeWidth: "29.06px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M639.06,405.357c8.791,-9.041 8.589,-23.519 -0.452,-32.31l-78.397,-76.232c-9.042,-8.792 -23.519,-8.589 -32.311,0.452c-8.791,9.041 -8.589,23.519 0.452,32.311l78.397,76.232c9.042,8.791 23.519,8.589 32.311,-0.453Z",
    style: {
      fill: "#0c193b",
      stroke: "#0c193b",
      strokeWidth: "1.45px"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-183.385,211.29,-211.29,-183.385,505.664,111.649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgItemSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/item_search.e4aa5111bd8da49fb7cd479187f76b30.svg";